import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  defaultHeight: {
    height: 64
  },
  root: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    width: "100%"
  },
  paper: {
    height: "calc(100vh - 210px)", //magic number (appbar + header)
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "0.5em"
    },
    "&::-webkit-scrollbar-track": {
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,.00)"
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.primary.light
    }
  },
  pointer: {
    cursor: "pointer"
  },
  drawer: {
    width: 280
  },
  subheader: {
    backgroundColor: theme.palette.background.paper,
    padding: 14
  },
  subheaderTitle: {
    fontWeight: theme.typography.fontWeightHeavy,
    maxWidth: 230,
    display: "inline-block"
  },
  totalAmount: {
    fontWeight: theme.typography.fontWeightHeavy
  },
  orderContainer: {
    flex: 1
  },
  margin14: {
    margin: theme.spacing(2)
  },
  link: {
    color: "#039be5",
    fontWeight: theme.typography.fontWeightMedium,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    }
  },
  white: {
    color: theme.palette.common.white
  },
  datePicker: {
    "& label.MuiFormLabel-root": {
      color: theme.palette.common.white
    },
    "& label.Mui-focused": {
      color: theme.palette.common.white
    },
    "& .MuiInput-underline:before, & .MuiInput-underline:after, & .MuiInput-underline:hover:before": {
      borderBottomColor: theme.palette.common.white
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: theme.palette.common.white
      },
      "&:hover fieldset": {
        borderColor: theme.palette.common.white
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.common.white
      }
    }
  }
}));
